module.exports = __webpack_public_path__ + "img/Macros.9c0af885.svg";